import React from 'react'
import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import WaveDivider from '../components/WaveDivider'
import { localizeTree } from '../i18n/localizeTree'

export default function NotFoundPage({ lang = 'da' }) {
  return localizeTree((
    <>
      <SeoHead
        lang="da"
        title="Siden blev ikke fundet (404) - Fanø Chokolade"
        description="Siden du leder efter findes desværre ikke eller er flyttet. Find vej tilbage til Fanø Chokolades søde univers."
        noIndex
      />

      <section className="min-h-[60vh] flex items-center justify-center py-20 px-6 sm:px-8">
        <div className="max-w-xl mx-auto text-center bg-white rounded-3xl p-8 sm:p-14 border border-[#C68D94]/20 shadow-sm">
          <span className="font-script text-6xl sm:text-7xl text-[#C68D94] font-normal block mb-2">
            404
          </span>
          <h1 className="font-script text-4xl sm:text-5xl text-[#3E3435] font-normal mb-3">
            Siden blev ikke fundet
          </h1>
          <WaveDivider className="text-[#C68D94]/50 mx-auto mb-5" />
          <p className="text-xs sm:text-sm text-[#3E3435]/80 font-light leading-relaxed mb-8">
            Vi kunne desværre ikke finde den side, du ledte efter. Måske er linket udløbet, eller siden er flyttet i forbindelse med vores opdatering.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="bg-[#C68D94] hover:bg-[#A35D67] text-white px-7 py-3 rounded-full text-xs font-semibold tracking-wider uppercase transition-colors shadow-sm"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/webshop"
              className="border border-[#C68D94] text-[#A35D67] hover:bg-[#F7ECEE] px-7 py-3 rounded-full text-xs font-semibold tracking-wider uppercase transition-colors"
            >
              Se Webshoppen
            </Link>
          </div>

          <div className="mt-8 pt-6 border-t border-[#C68D94]/15">
            <p className="text-xs text-stone-500">
              Har du brug for hjælp? Ring direkte til os på{' '}
              <a href="tel:60224704" className="text-[#A35D67] font-semibold whitespace-nowrap hover:underline">
                60 22 47 04
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  ), lang)
}
